import React from "react";
import "./_club-result-list.scss";
import ClubTile from "../../atoms/club-tile/club-tile";
import {ClubType} from "../../../types/ApiTypeDefinition/clubFinderResultTypes";
import ClubPlaceholderContent from "../../atoms/club-placeholder-content/club-placeholder-content";
import {AppVersionForTenants, Config} from "../../../constants/Config";
import ClubTileVersion2 from "../../version-2/atoms/club-tile-version-2/club-tile-version-2";

interface ClubResultListProptypes {
  clubFinderResult: ClubType[]|null;
  handleClubTileAction: any
  tenant: string
}

const ClubResultList = (props: ClubResultListProptypes): JSX.Element => {
  let clubList;
  const clubFinderResult = props.clubFinderResult;
  if (props.tenant == 'nzc') {
    clubList = clubFinderResult ? clubFinderResult.map((clubDetails: ClubType, index: number) =>
      <ClubTile clubDetails={clubDetails} clubLogoVisible={true} handleClubTileAction={props.handleClubTileAction}
                index={index} key={index}/>
    ): null;
  } else if (AppVersionForTenants.v2.tenants.includes(props.tenant)) {
    clubList = clubFinderResult ? clubFinderResult.map((clubDetails: ClubType, index: number) =>
      <ClubTileVersion2 clubDetails={clubDetails} clubLogoVisible={true} handleClubTileAction={props.handleClubTileAction}
                   index={index} key={index} tenant={props.tenant}/>
    ): null;
  }

  return (
    <>
      {props.clubFinderResult && props.clubFinderResult.length === 0 && props.tenant == 'nzc' && (
        <ClubPlaceholderContent placeHolderText={Config.search.noResultPlaceholder} tenant={props.tenant}/>
      )}

      {props.clubFinderResult && props.clubFinderResult.length > 0 && (
        <div className={`clubResultList ${props.tenant} ${AppVersionForTenants.v2.tenants.includes(props.tenant) ? 'v2-list' : ''}`}>
          {clubList}
        </div>
      )}
    </>
  )
}

export default ClubResultList;
